import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CACHE_DURATION } from '#/shared/constants';

const api = {
  host: 'https://ws.trimet.org',
  services: {
    vehicleRouteGeometry: {
      path: '/geoserver/wfs',
      defaultQuery: {
        request: 'GetFeature',
        typeName: 'ott:current_patterns',
        outputFormat: 'json',
      },
    },
  },
};

export const wsApi = createApi({
  reducerPath: 'wsApi',
  baseQuery: fetchBaseQuery({ baseUrl: api.host }),
  refetchOnReconnect: true,
  endpoints: build => ({
    getVehicleRouteGeometry: build.query({
      query: ({ tripId }) => {
        if (!tripId) return {};

        const { path, defaultQuery } = api.services.vehicleRouteGeometry;
        return {
          url: path,
          params: {
            ...defaultQuery,
            cql_filter: `id='${tripId}'`,
          },
        };
      },
      transformResponse: response => {
        return response?.features?.[0]?.geometry ?? null;
      },
      keepUnusedDataFor: CACHE_DURATION.ONE_MINUTE,
    }),
  }),
});

export const { useGetVehicleRouteGeometryQuery } = wsApi;
